(function () {
  function initCollectionDescription(root = document) {
    root.querySelectorAll('collection-description-toggle').forEach((wrapper) => {
      if (wrapper.dataset.initialized === 'true') return;

      const content = wrapper.querySelector('.collection-description__content');
      const button = wrapper.querySelector('.collection-description__toggle');

      if (!content || !button) return;

      wrapper.dataset.initialized = 'true';

      requestAnimationFrame(() => {
        if (content.scrollHeight <= content.clientHeight + 2) {
          button.hidden = true;
        }
      });

      button.addEventListener('click', function () {
        const expanded = content.classList.toggle('is-expanded');

        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded
          ? 'Citeste mai putin'
          : 'Citeste mai mult';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionDescription();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionDescription(event.target);
  });
})();